module.exports = __webpack_public_path__ + "static/media/Cats eyes 04_FRANSKA-mixdown.0c7420b9.mp3";